import { sentenceCase } from 'utils/stringHelpers';

import { DeletableItem, DeletableItemDisplayText } from '../types';
import { getItemsDeletionVerb, getItemsTypeName } from '../utils';

type DeletionHeaderProps = {
  content: DeletableItem[];
  folders: DeletableItem[];
  displayTextForContentItems: DeletableItemDisplayText;
};

export const DeletionHeader = ({
  content,
  folders,
  displayTextForContentItems,
}: DeletionHeaderProps) => {
  const deletionVerb = getItemsDeletionVerb(content, folders, displayTextForContentItems);
  const itemTypeName = getItemsTypeName(content, folders, displayTextForContentItems);
  return (
    <>
      {sentenceCase(deletionVerb)} {itemTypeName}?
    </>
  );
};
